import { getCostCentreDescription } from 'hooks/useGrid/gridFunctions';
import useApp from 'hooks/useApp';
import { useTranslation } from 'react-i18next';
import { getShortCC } from 'utils/text';
import Text from '@ingka/text';
import classes from './ContractHoursRow.module.scss';

export const ContractDetails = ({
    divisionName,
    costCentre,
}:{
    divisionName: string,
    costCentre: string,
}) => {
    const { orgSelection: { utils: { hierarchy } } } = useApp();
    const { t } = useTranslation();

    return (
        <>
            <td className={classes.details}>
                <Text textStyle="Body.M">{divisionName ?? t('N/A')}</Text>
            </td>
            <td className={classes.details}>
                <Text textStyle="Body.M">{`${getCostCentreDescription(costCentre, hierarchy?.costCentreHierarchy)} (${getShortCC(costCentre)})`}</Text>
            </td>
        </>

    );
};
